import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';
import { enumValue, gapIsPending } from '~/util';

const propTypes = {
    focGap: PropTypes.shape().isRequired,
    patientId: PropTypes.number.isRequired,
    tab: PropTypes.string.isRequired,
    rolePermission: PropTypes.bool.isRequired,
    setDisabled: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export function FocClear({
    focGap,
    patientId,
    tab,
    rolePermission,
    setDisabled,
    onSuccess,
    disabled,
}) {
    const context = React.useContext(ServicesContext);
    const [saving, setSaving] = React.useState(false);

    async function handleClear() {
        try {
            setSaving(true);
            setDisabled(true);
            if (focGap.submission_answer?.status === enumValue(['submission', 'status', 'New'])) {
                // Delete submission_answer
                await context.patient.deleteSubmissionAnswer(
                    enumValue(['gap', 'type', 'FOC Gap']),
                    focGap.id,
                    focGap.submission_answer.id
                );
            } else {
                // This submission was previously sent, so we purposefully
                // change this to null rather than deleting
                await context.patient.updateFocGap(focGap.id, patientId, {
                    submission_answer: null,
                    updated_at: focGap.updated_at,
                });
            }
            onSuccess();
        } catch (e) {
            setSaving(false);
            setDisabled(false);
        }
    }

    if (
        tab !== 'Measures' ||
        !gapIsPending(focGap) ||
        !focGap.submission_answer ||
        !rolePermission
    ) {
        return null;
    }

    return (
        <div className="text-center">
            <button
                className="btn btn-warning"
                type="button"
                onClick={handleClear}
                disabled={disabled}
            >
                {saving && <Spinner animation="border" role="status" size="sm" className="me-1" />}
                Clear
            </button>
        </div>
    );
}

FocClear.propTypes = propTypes;
